import React, { useState } from 'react';
import { PartPrices, PqlPriceType } from 'types/UFOTypes';

export type PaymentType = {
  credit_card_token?: string | null;
  credit_card_last_four?: string | null;
  po_number?: string | null;
  authorization_number?: string | null;
  reference_number?: string | null;
  payment_type?: string | null;
};
export interface PartPayload {
  part_id: string;
  quantity: number;
  comment?: string;
  part_description: string;
  related_to?: string;
  ispql: boolean;
  invoice_price?: number;
  final_invoice_price?: number;
}

type PricesContextType = {
  servicesPrices: PartPrices[] | null;
  setServicesPrices: (p: PartPrices[] | null) => void;
  pqlServicesPrices: PqlPriceType[] | null;
  setPqlServicesPrices: (p: PqlPriceType[] | null) => void;
  selectedTiresAndProducts: { mspn: string; qty: number; is_pql: boolean }[];
  setSelectedTiresAndProducts: (v: { mspn: string; qty: number; is_pql: boolean }[]) => void;
  pricingErrorMspn: string[];
  addPricingErrorMspn: (mspn: string) => void;
};
export const PricesContext = React.createContext<PricesContextType>({} as PricesContextType);

export function usePricesContext() {
  const [servicesPrices, setServicesPrices] = useState<PartPrices[] | null>(null);
  const [pqlServicesPrices, setPqlServicesPrices] = useState<PqlPriceType[] | null>(null);
  const [pricingErrorMspn, setPricingErrorMspn] = useState<string[]>([]);
  const [selectedTiresAndProducts, setSelectedTiresAndProducts] = useState<
    { mspn: string; qty: number; is_pql: boolean }[]
  >([]);

  const addPricingErrorMspn = (mspn: string) => {
    if (!pricingErrorMspn.includes(mspn)) setPricingErrorMspn([...pricingErrorMspn, mspn]);
  };

  return {
    servicesPrices,
    setServicesPrices,
    addPricingErrorMspn,
    pqlServicesPrices,
    setPqlServicesPrices,
    pricingErrorMspn,
    selectedTiresAndProducts,
    setSelectedTiresAndProducts,
  };
}
